// AppRoute.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Products from "./components/Products";
import NavbarHeader from "./components/NavbarHeader";
import AboutOurCompany from "./components/AboutOurCompany";

const AppRoute = () => {
  return (
    <Router>
      <NavbarHeader />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
         <Route path="/about-our-company" element={<AboutOurCompany />} />
      </Routes>
    </Router>
  );
};

export default AppRoute;
